var React = require('react');
var _ = require("underscore");

var T = React.PropTypes;

var Dialog = require('../cutil/Dialog');


var HotelOrderDialog = React.createClass({
    propTypes: {
      hotelList: T.array
    },
    getDefaultProps(){
        return {
            hotelList:[]
        }  
    },
    getInitialState(){
        return{
            isOpen: false
        }
    },
    handle_click(){
        this.setState({
            isOpen: true
        })
    },
    handle_close(){
      this.setState({
          isOpen: false
      })
    },
    render(){

        var hotelList = this.props.hotelList;

        if( hotelList.length === 0 ){
            return null
        }
        
        var title = '酒店清单';
        return (
            <div className="mod-hotel-dialog-trigger" onClick={ this.handle_click }>
                <span className="hotel-order">{ title }</span>
                <Dialog title={ title } isOpen={this.state.isOpen} onClose={this.handle_close} >
                    <ul>
                        {
                            hotelList.map((item,index)=>{
                                return(
                                    <li className="hotel-item" key={index}>
                                        {item.name}
                                    </li>
                                )
                            })
                        }
                    </ul>
                </Dialog>
            </div>
        )
    }

});

module.exports = HotelOrderDialog;



/** WEBPACK FOOTER **
 ** ./script/detail-m/HotelOrderDialog.jsx
 **/